/**
 * @typedef {{
 *     Company: string,
 *     FirstName: string,
 *     LastName: string,
 *     Email: string,
 *     Country: string
 * }} UngatePayload
 */

/**
 * @param roiGateFormData {RoiGateFormData}
 * @return {UngatePayload}
 */
module.exports = function convertRoiGateFormDataToUngatePayload(roiGateFormData) {
    return {
        Company: roiGateFormData["Company"],
        FirstName: roiGateFormData["FirstName"],
        LastName: roiGateFormData["LastName"],
        Email: roiGateFormData["Email"],
        Country: roiGateFormData["Country"],
    };
}
